import { render } from "./suoluomenItem.vue?vue&type=template&id=5fddc2c2&scoped=true"
import script from "./suoluomenItem.vue?vue&type=script&lang=js"
export * from "./suoluomenItem.vue?vue&type=script&lang=js"

import "./suoluomenItem.vue?vue&type=style&index=0&id=5fddc2c2&lang=less&scoped=true"

import exportComponent from "/Users/ryancompany/works/bao/xinyuanyiyuan/pet-mobile-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fddc2c2"]])

export default __exports__